import React 				from 'react';
import BLComponent			from '../../core/_BLComponent.jsx';


export default class PCCList extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
	}

	componentDidMount() 
	{
	}

	render()
	{
		const {pccList, itemIdx} = this.props.data;
		
		if (pccList[0] == null) pccList[0] = "--";
		
		const len = pccList.length;
		const pccMore = pccList.map( (pcc, pccIdx)=>{
			return(
				<React.Fragment key={"pcc-" + pccIdx}>{(pccIdx > 0)?", ":""}{pcc}</React.Fragment>
			);
		})

		if (len == 0) return null;

		return (
			<div>
				<div className={"first-pcc-" + itemIdx}>PCC : <span className="l-margin-right--sm ">{pccList[0]}</span>  {(len > 1)&&<span className="text--link l-cursor-pointer" onClick={()=>this.showPCCMore(itemIdx)}>+ {(len-1)} more</span>}</div> 
				<div className={"l-hide all-pcc-" + itemIdx}>PCC : <span className="l-margin-right--sm ">{pccMore}</span> {(len > 1)&&<span className="text--link l-cursor-pointer" onClick={()=>this.hidePCCMore(itemIdx)}> less</span>}</div> 
				
			</div>
		);
	}

	showPCCMore(itemIdx) 
	{
		$(".all-pcc-" + itemIdx).show();
		$(".first-pcc-" + itemIdx).hide();
		
	}
	hidePCCMore(itemIdx)
	{
		$(".all-pcc-" + itemIdx).hide();
		$(".first-pcc-" + itemIdx).show();
	}
}